import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, BillItemsByChargeEntryCodeController, BillItemsByChargeEntryCodeRequest, X_BillItemsController, x_BillDetailsRequest, BillDetailsInfoController, X_BillReceiptsController, X_BillHeaderController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, AdmissionsByCodeController, AdmissionsByCodeRequest, AdmissionDetailsInfoController, BillAdvancesListController, BillAdvancesListRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'admbillsummary',
  templateUrl: './admbillsummary.component.html',
  styleUrls: ['./admbillsummary.component.scss']
})

export class AdmbillsummaryComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  public logo: string = "";
  public HeaderLine1: string = "";
  public HeaderLine2: string = "";
  public GST: string;
  public DL: string;
  public Date: Date;
  public PatientId: string;
  public AdmissionCode: any;
  public PatientName: string;
  public PayeeName: string;
  public Toatalbill: number; 
  public PaidBill: number;
  public PatientCode: any;
  public Branchname: string;
  public DiscountSum: number;
  public FormattedCode: string;
  public TotalAdvance: number;

  CurrentX_BillHeaderController: X_BillHeaderController;
  //FollicularScanEndInfo: FollicularScanDetailController;
  // BillHeader: X_BillHeaderController[];
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    //alert("ScansData")
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.AdmissionCode = this.route.snapshot.paramMap.get('AdmissionCode');
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    //this.StartRefreshing();

    this.CurrentX_BillHeaderRequest.ChargeEntry = 0;
    this.CurrentX_BillHeaderRequest.AdmissionCode = this.AdmissionCode;
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 40;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          //alert(this.CurrentX_BillHeaderController[0].PatientName);
          //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadBillItems();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillItemsController: X_BillItemsController[];
  //FollicularScanEndInfo: FollicularScanDetailController;
  //BillHeader: X_BillHeaderController[];
  CurrentX_BillItemsRequest: x_BillDetailsRequest;

  BillData: BillDetailsInfoController;
  BillData2: X_BillItemsController;

  LoadBillItems() {
    //alert("ScansData")
    this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.AdmissionCode = this.route.snapshot.paramMap.get('AdmissionCode');
    this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillItemsController();
  }

  GetX_BillItemsController() {
    //this.StartRefreshing();

    this.CurrentX_BillItemsRequest.ChargeEntry = 0;
    this.CurrentX_BillItemsRequest.AdmissionCode = this.AdmissionCode;
    this.CurrentX_BillItemsRequest.ConditionalOperator = 40;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillItemsController(this.CurrentX_BillItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillData = this.ApiResData.Result;
          this.CurrentX_BillItemsController = this.BillData.Items;
          this.BillData2 = this.CurrentX_BillItemsController[0];
          this.DiscountSum = this.CurrentX_BillItemsController.filter(l => l.Discount)
            .reduce((sum, current) => sum + current.Discount, 0);
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadBills();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillReceiptsController: X_BillReceiptsController[];

  CurrentX_BillReceiptsRequest: x_BillDetailsRequest;

  BillDataReceipt: BillDetailsInfoController;

  LoadBillReceipts() {
    //alert("ScansData")
    this.CurrentX_BillReceiptsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    //this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
    this.CurrentX_BillReceiptsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillReceiptsController();
  }

  GetX_BillReceiptsController() {
    //this.StartRefreshing();
    this.CurrentX_BillReceiptsRequest.ChargeEntry = 0;
    this.CurrentX_BillReceiptsRequest.AdmissionCode = this.AdmissionCode;
    this.CurrentX_BillReceiptsRequest.ConditionalOperator = 40;

    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillReceiptsController(this.CurrentX_BillReceiptsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillDataReceipt = this.ApiResData.Result;
          this.CurrentX_BillReceiptsController = this.BillDataReceipt.Receipts;
          this.PatientName = this.CurrentX_BillReceiptsController[0].PatientName;
          this.PayeeName = this.CurrentX_BillReceiptsController[0].PayeeName;
          this.Toatalbill = this.CurrentX_BillReceiptsController[0].AmountPayable;
          this.PaidBill = this.CurrentX_BillReceiptsController[0].AmountPaid;



          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //this.LoadBills();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentBillAdvancesListController: BillAdvancesListController[];

  CurrentBillAdvancesListRequest: BillAdvancesListRequest;



  LoadAdvances() {
    this.CurrentBillAdvancesListRequest = new BillAdvancesListRequest();
    this.CurrentBillAdvancesListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.PatientCode = this.route.snapshot.paramMap.get('PatientCode');
    this.CurrentBillAdvancesListRequest.PatientCode = this.PatientCode;
    this.CurrentBillAdvancesListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentBillAdvancesListRequest.ConditionalOperator = 10;
    this.GetBillAdvancesListController();
  }
  GetBillAdvancesListController() {
    this.StartRefreshing();


    this.actorservice.GetBillAdvancesListController(this.CurrentBillAdvancesListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentBillAdvancesListController = this.ApiResData.Result;
          this.TotalAdvance = this.CurrentBillAdvancesListController.filter(l => l.AdvanceAmount)
            .reduce((sum, current) => sum + current.AdvanceAmount, 0);
          //this.ChargeEntryCode = this.CurrentBillDetailsInfoController[0].ChargeEntry;

          //this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentAdmissionsByCodeController: AdmissionsByCodeController[];
  CurrentAdmissionsByCodeRequest: AdmissionsByCodeRequest;
  AdmissionData: AdmissionDetailsInfoController;
  SelectedAdmission: AdmissionsByCodeController;
  LoadAdmissionsDetails() {
    this.CurrentAdmissionsByCodeRequest = new AdmissionsByCodeRequest();
    this.AdmissionCode = this.route.snapshot.paramMap.get('AdmissionCode');
    this.CurrentAdmissionsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetAdmissionsByCodeController();
  }

  GetAdmissionsByCodeController() {
    this.StartRefreshing();
    this.CurrentAdmissionsByCodeRequest.ConditionalOperator = 10;
    //this.CurrentAdmissionsListRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAdmissionsByCodeRequest.AdmissionCode = this.AdmissionCode;
    this.CurrentAdmissionsByCodeRequest.FacilityCode = AppData.Instance().SelectedFacilityCode;

    this.actorservice.GetAdmissionsByCodeController(this.CurrentAdmissionsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.AdmissionData = this.ApiResData.Result;
          this.CurrentAdmissionsByCodeController = this.AdmissionData.AdmissionItems;
          this.SelectedAdmission = this.AdmissionData.AdmissionItems[0];
          //this.pdata = this.CurrentMaterialConsumptionEntries2Controller;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.FormattedCode = this.route.snapshot.paramMap.get('PatientId');
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadBills();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentBillItemsByChargeEntryCodeController: BillItemsByChargeEntryCodeController[];
  CurrentBillItemsByChargeEntryCodeRequest: BillItemsByChargeEntryCodeRequest;



  LoadBills() {
    this.CurrentBillItemsByChargeEntryCodeRequest = new BillItemsByChargeEntryCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentBillItemsByChargeEntryCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentBillItemsByChargeEntryCodeRequest.ChargeEntryCode = 10074;
    this.CurrentBillItemsByChargeEntryCodeRequest.ConditionalOperator = 10;
    this.GetBillItemsByChargeEntryCodeController();
  }
  GetBillItemsByChargeEntryCodeController() {
    this.StartRefreshing();


    this.actorservice.GetBillItemsByChargeEntryCodeController(this.CurrentBillItemsByChargeEntryCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentBillItemsByChargeEntryCodeController = this.ApiResData.Result;
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady()
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    this.logo = AppData.Instance().cas.Hlogo;
    this.HeaderLine1 = AppData.Instance().cas.ClientHeaderLine1;
    this.HeaderLine2 = AppData.Instance().cas.ClientHeaderLine2;
    this.Date = new Date();
    this.Branchname = AppData.Instance().SelectedBranchName;
    this.AdmissionCode = this.route.snapshot.paramMap.get('AdmissionCode');
    this.PatientId = this.route.snapshot.paramMap.get('PatientId');
    this.PatientCode = this.route.snapshot.paramMap.get('PatientCode');
    this.GST = AppData.Instance().GetDataParam('TinNo');
    this.DL = AppData.Instance().GetDataParam('DrugLicenceNo');
    this.LoadBillHeader();
    this.LoadPatients();
    this.LoadAdmissionsDetails();
    this.LoadAdvances();
    this.LoadBillReceipts();
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








